import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import moment from 'moment';
import { ModalUtils, Validation } from '@singularsystems/neo-core';
import ManageOrganisationComponentVM from './ManageOrganisationComponentVM';

interface IManageOrganisationComponentProps {
    viewModel: ManageOrganisationComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageOrganisationComponent extends React.Component<IManageOrganisationComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;
        return (
            <div>
                {<Neo.Card title={viewModel.manageOrganisation.organisationId > 0 ? TextConstants.Titles.EditOrganisation : TextConstants.Titles.AddNewOrganisation}>
                            <Neo.Form model={viewModel.manageOrganisation}
                            validationDisplayMode={Validation.DisplayMode.AfterBlur}
                            onInvalid={this.onFormInvalid}
                            onSubmit={() => this.props.onSave()}>

                        <div>
                            <Neo.FormGroup
                                            bind={viewModel.manageOrganisation.meta.organisationName}
                                            label={TextConstants.Labels.OrganisationName} 
                                            />
                        </div>
                        <div>
                            <Neo.FormGroup label={TextConstants.Labels.Currency} 
                            bind={viewModel.manageOrganisation.meta.nominatedCurrencyId}
                            select={{ items: viewModel.CurrencyDataList }} />
                        </div>
                        <div className="row customMarginTop29 float-right pr-3">
                                    <Neo.Button 
                                        variant="primary" className="ml-3 col-md-2" isSubmit
                                    >{TextConstants.Buttons.Save}</Neo.Button>
                                    <Neo.Button className="ml-3 col-md-2"
                                        onClick={() => this.props.onCancel()}
                                        variant="secondary"
                                    >{TextConstants.Buttons.Cancel}</Neo.Button>
                                </div>
                    </Neo.Form>
                </Neo.Card>}
            </div>
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated){ 
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidOrganisation);
        }
    }
}